import React from "react";
import TablaCargaCodigos from "js/pages/Admin/Programa/CargadeCodigos/Tabla";

function CargaCodigos(props) {
  return <TablaCargaCodigos {...props} />;
}

export default CargaCodigos;
